import { Accordion, Box } from '@opendoor/bricks-next';

import type { EntryComponent } from '../../cms/entries/entries';
import type { IComponentAccordionList } from '../../declarations/contentful';

const renderAccordionList = (entry: IComponentAccordionList) => {
  const items = (entry.fields.items || []).filter(Boolean).map(({ fields }) => ({
    title: fields?.title || '',
    description: fields?.body || '',
  }));

  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }} width="100%">
      <Accordion
        variant="medium"
        size="medium"
        isFullWidth
        items={items}
        showDivider
        analyticsName="cosmos-articles-accordion-list"
      />
    </Box>
  );
};

const AccordionList: EntryComponent<IComponentAccordionList> = {
  render: renderAccordionList,
};

export default AccordionList;
